import React from 'react';
import { connect } from 'react-redux';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import {
  CardMedia,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs
} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import TabPanelDetail from '../atoms/TabPanelDetail';
import ImagePreview from './ImagePreview';

const styles = {
  root: {
    width: '100%'
  },
  detailTable: {
    width: '100%',
    padding: 15
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 200
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  noBorderCell: {
    borderBottom: 'none',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  },
  tabpanelHeader: {
    padding: '0 40px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: 165,

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  panelDetail: {
    padding: '15px 30px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('tab', 'setTab', 0),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withHandlers({}),
  lifecycle({
    componentDidMount() {
      if (this.props.detail.paymentGroupId) {
        if (this.props.detail.groupRegistrationId) {
          this.props.setHaveRegistrationId(1);
        } else {
          this.props.setHaveRegistrationId(0);
        }
      } else if (this.props.detail.registrationId) {
        this.props.setHaveRegistrationId(1);
      } else {
        this.props.setHaveRegistrationId(0);
      }
    }
  })
);
const Main = enhance(
  ({
    classes,
    tab,
    setTab,
    detail,
    roles,
    isFukuoka,
    groupDisplayLimit,
    haveRegistrationId
  }) => {
    const handleChange = (event, newValue) => {
      setTab(newValue);
    };
    const enableShopBank = detail.bankSwitchable;
    return (
      <div className={classes.root}>
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabpanelHeader}
        >
          <Tab
            label="基本情報（必須）"
            className={classNames(
              classes.btnTabpanel,
              tab === 0 && classes.tabSelected
            )}
          />
          <Tab
            label="その他（任意）"
            className={classNames(
              classes.btnTabpanel,
              tab === 1 && classes.tabSelected
            )}
          />
          {!isFukuoka && (
            <Tab
              label="高度な設定（任意）"
              className={classNames(
                classes.btnTabpanel,
                tab === 2 && classes.tabSelected
              )}
            />
          )}
        </Tabs>

        <TabPanelDetail value={tab} index={0}>
          <div className={classes.panelDetail}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室名' : '店舗名'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室名かな' : '店舗名かな'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopNameKana}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室電話番号' : '店舗電話番号'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {' '}
                    {detail.phone}
                    {roles && !roles.isShop && (
                      <frameElement>
                        {'('}
                        {detail.showPhone ? `表示` : `非表示`}
                        {')'}
                      </frameElement>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    郵便番号
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.zipCode}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    都道府県
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.prefectures}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    市区町村
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.city}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    町域・番地
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.address}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    建物名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.building}
                  </TableCell>
                </TableRow>

                {!isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗カテゴリー
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.shopCategories.map(item => {
                        if (
                          detail.shopCategoryId &&
                          detail.shopCategoryId.toString() ===
                            item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                    </TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    運営会社
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopGroupName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    ご担当者名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopContactName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    所属部署
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.department}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    電話番号（担当者）
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.contactPhone}
                  </TableCell>
                </TableRow>

                {!isFukuoka && !groupDisplayLimit && !detail.paymentGroupId && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        インボイス制度 適格事業者登録
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {haveRegistrationId ? '登録済み' : '未登録'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        適格事業者登録番号
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {// eslint-disable-next-line no-nested-ternary
                        detail.paymentGroupId
                          ? detail.groupRegistrationId
                          : haveRegistrationId
                          ? detail.registrationId
                          : undefined}
                      </TableCell>
                    </TableRow>
                  </>
                )}

                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メールアドレス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.email}
                  </TableCell>
                </TableRow>

                {enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      {isFukuoka ? '振込先' : '売上受取方法'}
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.depositManageStr ===
                        '銀行口座で直接受取（月1回入金）（オプション）' &&
                      isFukuoka
                        ? '銀行口座'
                        : detail.depositManageStr}
                    </TableCell>
                  </TableRow>
                )}

                {detail.depositManage === 'NONSELF' && enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      銀行名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.bankName}
                    </TableCell>
                  </TableRow>
                )}

                {detail.depositManage === 'NONSELF' && enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      支店名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.bankBranchName}
                    </TableCell>
                  </TableRow>
                )}

                {detail.depositManage === 'NONSELF' && enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座種別
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.bankAccountTypeStr}
                    </TableCell>
                  </TableRow>
                )}

                {detail.depositManage === 'NONSELF' && enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.bankAccountNumber}
                    </TableCell>
                  </TableRow>
                )}

                {detail.depositManage === 'NONSELF' && enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座名義
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.bankAccountHolder}
                    </TableCell>
                  </TableRow>
                )}
                {detail.createdAt && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      登録日時
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.createdAt}
                    </TableCell>
                  </TableRow>
                )}
                {detail.updatedAt && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      更新日時
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {detail.updatedAt}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </TabPanelDetail>

        <TabPanelDetail value={tab} index={1}>
          <div className={classes.panelDetail}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室概要' : '店舗概要'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.introduction}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    営業時間
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.businessHours}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    定休日
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.holiday}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '平均金額' : '価格帯'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.priceRange}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    最寄り駅
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.nearestStation}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    アクセス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.access}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    WebページURL
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.webPage}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>タグ</TableCell>
                  <TableCell className={classes.tableCellData}>
                    <div>
                      {detail.tags.map(tag => {
                        return (
                          <span className={classes.tag}>{tag.tagName}</span>
                        );
                      })}
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>画像</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.images &&
                      detail.images.map(img => (
                        <ImagePreview previewImage={img.image} />
                      ))}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>SNS</TableCell>
                  <TableCell className={classes.tableCellData}>
                    <div className={classes.margin}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Facebook"
                            height="24"
                            image="/images/icon_facebook.png"
                            title="Facebook"
                            className={classes.marginBottom12}
                          />
                        </Grid>
                        {detail.snsFacebook && (
                          <Grid item xs={12} sm container>
                            <TableCell className={classes.noBorderCell}>
                              {detail.snsFacebook}
                            </TableCell>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Twitter"
                            height="24"
                            image="/images/icon_twitter.png"
                            title="Twitter"
                            className={classes.marginBottom12}
                          />
                        </Grid>
                        {detail.snsTwitter && (
                          <Grid item xs={12} sm container>
                            <TableCell className={classes.noBorderCell}>
                              {detail.snsTwitter}
                            </TableCell>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Instagram"
                            height="24"
                            image="/images/icon_instagram.png"
                            title="Instagram"
                            className={classes.marginBottom12}
                          />
                        </Grid>
                        {detail.snsInstagram && (
                          <Grid item xs={12} sm container>
                            <TableCell className={classes.noBorderCell}>
                              {detail.snsInstagram}
                            </TableCell>
                          </Grid>
                        )}
                      </Grid>
                    </div>
                  </TableCell>
                </TableRow>
                {!isFukuoka && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        座席
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.numberSit}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        禁煙/喫煙
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {detail.smoking}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    駐車場
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.parking}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </TabPanelDetail>

        <TabPanelDetail value={tab} index={2}>
          <div className={classes.panelDetail}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗詳細表示制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.stealthModeStr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    誰でもごち制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.gochiRestrictionStr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし金額指定チケット利用の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopDetail &&
                    detail.shopDetail.allowMenuPriceShashoku
                      ? '利用する'
                      : '利用しない'}
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし現金授受の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.cashAllowed ? '受け付ける' : '受け付けない'}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    差額決済利用可否
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {detail.shopDetail && detail.shopDetail.allowGapPayment
                      ? '可能 （券売機で営業または通販サービス）'
                      : '不可（上記以外）'}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </TabPanelDetail>
      </div>
    );
  }
);
export default withRouter(withStyles(styles)(Main));
